(function (angular) {
	'use strict';

	angular
		.module('goalVerificationModule')
		.controller('GoalVerification', [
			'urlFactory',
			GoalVerificationFunction
		]);

	function GoalVerificationFunction(urlFactory) {
		var  goalVerification = this;

		goalVerification.goalName = urlFactory.getUrlParam('goalName');

		goalVerification.confirmSelection = function(){
			var nameToSlug = {
				'Long-Term Growth' : 'long-term-growth',
				'Balanced Investing' : 'balanced-investing',
				'Supplemental Income' : 'supplemental-income'
			};

			if(goalVerification.goalName === 'Starter Portfolio') {
				urlFactory.redirect('/starter-portfolio/details');
			} else {
				var slug = nameToSlug[goalVerification.goalName];
				urlFactory.redirect('/investments/advanced-plans/' + slug);
			}
		};
	}
})(window.angular);